import { api } from '../creat-api'
/**
 * 发布管理
 * 节目推送接口
 **/
export function fetchProgramsPush (params) {
  return api({
    method: 'POST',
    url: '/programs/push',
    data: params
  })
}
// 批量推送
export function fetchProgramsPushs (params) {
  return api({
    method: 'POST',
    url: '/programs/pushs',
    data: params
  })
}
/**
 * 节目集推送接口
 **/
export function fetchSetsProgramsPush (params) {
  return api({
    method: 'POST',
    url: '/programSets/push',
    data: params
  })
}
export function fetchProgramCont (params) {
  return api({
    url: '/programs/content',
    params
  })
}
// 站点查询接口

export function fetchSiteApps (params) {
  return api({
    url: '/siteApps/getSiteAppsBySystemIds',
    params
  })
}
/**
 * 发布管理
 * 节目集列表的接口
 **/
export function fetchProgramSets (params) {
  return api({
    url: '/programSets/queryProgramSetsForAudit',
    params
  })
}
